// Removes secrets from RUM events before they leave the browser.
//
// AngularJS $http rejections, ui-router transition errors and Angular's ErrorHandler are logged with the
// whole request config, so console errors carry the request headers (Authorization holds the raw access
// token, plus API-TOKEN and x-aws-waf-token) and sometimes the request body. Only string fields that the
// SDK lets beforeSend change are touched.

const REDACTED = '[redacted]';

const SECRET_KEYS = 'authorization|cookie|[\\w-]*token[\\w-]*|password|newpassword|senha|novasenha|senhaatual';

// "key": "value", also escaped inside another JSON string: \"key\":\"value\"
const JSON_PAIR = new RegExp('(\\\\?"(?:' + SECRET_KEYS + ')\\\\?"\\s*:\\s*\\\\?")[^"\\\\]*', 'gi');

// key: value / key=value outside JSON
const PLAIN_PAIR = /\b(authorization|api-token|x-aws-waf-token|x-csrf-token)(\s*[:=]\s*)(bearer\s+)?[^\s,;"'&}\]]+/gi;

const BEARER = /\b(bearer\s+)[\w.~+\/=-]+/gi;

const JWT = /\beyJ[\w-]+\.[\w-]+\.[\w-]*/g;

// Auth parameters in URLs: Keycloak callback (code, state, session_state), password reset link (uuid)
const URL_PARAM = /([?&#;](?:access_token|id_token|refresh_token|token|code|state|session_state|uuid|password|senha)=)[^&#\s"']*/gi;

export function scrubSecrets(text: string): string {
  if (typeof text !== 'string' || !text) {
    return text;
  }
  return text
    .replace(JSON_PAIR, '$1' + REDACTED)
    .replace(PLAIN_PAIR, '$1$2' + REDACTED)
    .replace(BEARER, '$1' + REDACTED)
    .replace(JWT, REDACTED)
    .replace(URL_PARAM, '$1' + REDACTED);
}

function scrubField(obj: any, key: string): void {
  if (obj && typeof obj[key] === 'string') {
    obj[key] = scrubSecrets(obj[key]);
  }
}

export function scrubRumEvent(event: any): void {
  if (event.error) {
    scrubField(event.error, 'message');
    scrubField(event.error, 'stack');
    scrubField(event.error.resource, 'url');
  }
  scrubField(event.resource, 'url');
  scrubField(event.view, 'url');
  scrubField(event.view, 'referrer');
  if (event.action) {
    scrubField(event.action.target, 'name');
  }
}
